import { render, staticRenderFns } from "./PanelVerbatim.vue?vue&type=template&id=443ededa&scoped=true&"
import script from "./PanelVerbatim.vue?vue&type=script&lang=js&"
export * from "./PanelVerbatim.vue?vue&type=script&lang=js&"
import style0 from "./PanelVerbatim.vue?vue&type=style&index=0&id=443ededa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443ededa",
  null
  
)

export default component.exports